import { useState } from 'react';

import { HiOutlinePhone, HiOutlineUserCircle } from 'react-icons/hi';

import useProfile from '@/modules/core/hooks/useProfileHook';
import DeleteAccountTab from '@/modules/profile/components/DeleteAccountTab';
import Button from '@/tayara-kit/Button';
import Input from '@/tayara-kit/Input';
import Text from '@/tayara-kit/Text';

const ProfileDetailsTab = ({
  username,
  phone,
  updateUserState,
  onClickSubmit,
}: any) => {
  const [showModal, setShowModal] = useState(false);
  const { userData, deleteAccount } = useProfile();
  return (
    <>
      {showModal && (
        <>
          <div className="absolute top-0 left-0 w-full h-full  bg-black opacity-50 z-[9999]"></div>
          <div className="max-w-max max-h-max fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[9999]	">
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
              <button
                onClick={() => setShowModal(false)}
                type="button"
                className="absolute top-3 right-2.5 text-gray-400 text-sm p-1.5"
                data-modal-toggle="popup-modal"
              >
                <svg
                  aria-hidden="true"
                  className="w-5 h-5 rounded-full fill-primary self-end cursor-pointer"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
              <div className="w-max p-5 md:p-14 text-center ">
                <svg
                  aria-hidden="true"
                  className="mx-auto mb-4 text-primary w-14 h-14"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <h3 className="mb-5 text-lg font-normal text-primary">
                  Vous êtes sûr de supprimer votre compte?
                </h3>
                <button
                  onClick={() => deleteAccount('delete')}
                  data-modal-toggle="popup-modal"
                  type="button"
                  className="m-2 text-white bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                >
                  Oui, je suis sûr!
                </button>
                <button
                  onClick={() => setShowModal(false)}
                  data-modal-toggle="popup-modal"
                  type="button"
                  className="text-gray-700 bg-white  focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                >
                  annuler
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="flex flex-col flex-wrap gap-6 mt-4">
        <div className="lg:w-[50%] w-full">
          <Text
            as="h2"
            text="Mes informations"
            className="text-2xl text-gray-600 font-bold md:mb-2"
          />
          {/* Username and phone number */}
          <div className="w-full flex flex-col md:flex-row flex-wrap gap-4">
            <div className="w-full">
              <Text
                as="label"
                text={"Nom d'utilisateur"}
                className="text-xs font-bold text-gray-600 "
              />
              <Input
                value={username}
                onChange={(e) => updateUserState('fullname', e.target.value)}
                type="text"
                startIcon={HiOutlineUserCircle}
                placeholder={username}
              />
            </div>

            <div className="w-full">
              <Text
                as="label"
                text="Numéro du téléphone"
                className="text-xs font-bold text-gray-600"
              />
              <Input
                value={phone}
                disabled={true}
                onChange={(e) => updateUserState('phone', e.target.value)}
                type="text"
                startIcon={HiOutlinePhone}
                placeholder={phone}
              />
            </div>
            {/* //remove email */}
            {/* <div className="basis-[51%]">
          <Text
            as="label"
            text="Email"
            className="text-xs font-bold text-gray-600"
          />
          <Input
            type="email"
            onChange={(e) => updateUserState('email', e.target.value)}
            startIcon={HiOutlineMail}
            value={email}
            placeholder={email || 'Ajouter une adresse électronique'}
          />
        </div> */}
          </div>
          <div className="mt-8 flex">
            <Button
              aria-label="Mettre à jours med informations"
              onClick={onClickSubmit}
              className="btn-primary"
            >
              Mettre à jour mes informations
            </Button>
          </div>
        </div>
        <div className="lg:w-[50%] w-full mt-6">
          <DeleteAccountTab id={userData.kcid} setShowModal={setShowModal} />
        </div>
      </div>
    </>
  );
};

export default ProfileDetailsTab;
